enum MotorDesign {
  IEC = 0 as number,
  NEMA = 1 as number
}

export default MotorDesign
export const MotorDesignList: {
  key: string
  value: MotorDesign
}[] = Object.entries(MotorDesign)
  .map(([key, value]) => ({ key, value: value as MotorDesign }))
  .filter(tuple => typeof (tuple.value as any) !== 'string')
